<template>
  <div class="financeManage-precept-page">
    <p class="hasBottomLine">平台抵押借贷账户管理</p>
    <!-- <div class="header-seach-box">
      <div class="inputWithSelectBox">
        <el-input placeholder="请输入币名称"  v-model="serchInfo.selectCoin" class="input-with-select">
          <el-button slot="append" disabled @click="getPageListInfo()" icon="el-icon-search">搜索</el-button>
        </el-input>
      </div>
    </div> -->
    <div class="table-box">
      <el-table :data="accountListInfo" border style="width: 99.9%">
        <el-table-column prop="coinType" label="币种"> </el-table-column>
        <el-table-column prop="balance" label="借贷宝账户总资产"> </el-table-column>
        <el-table-column prop="blastAmount" label="累计已强平还款资产"> </el-table-column>
        <el-table-column prop="borrowAmount" label="累计已借贷资产"> </el-table-column>

        <el-table-column prop="returnAmount" label="累计用户主动还款资产"> </el-table-column>
        <el-table-column prop="mortgageAmount" label="用户累计抵押中资产"> </el-table-column>
        <el-table-column prop="maxDay" label="操作" width="200">
          <template>
            <el-button type="primary" disabled>操作明细</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer-box">
      <!-- <el-pagination
        @size-change="sizeChange"
        @current-change="pageChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="accountListTotal"
      >
      </el-pagination> -->
    </div>
  </div>
</template>

<script>
import "../store";
import api from "../api";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "Precept",
  data() {
    return {
      currentPage: 1,
      pageSize: 10
    };
  },
  computed: {
    ...mapState("FinanceManage", ["accountListInfo"])
  },
  methods: {
    ...mapActions("FinanceManage", ["getAccountList"]),
    hanldSelectType(){
       this.serchInfo.selectCoin=''
    },
    sizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    pageChange(val) {
      console.log(`当前页: ${val}`);
      this.getPageListInfo();
    },

    getPageListInfo() {
      let borrowCoin = "";
      let mortgageCoin = "";
    
      let postData = {
        page: this.currentPage,
        size: this.pageSize
      };

      this.getAccountList();
    },
    handleSearch() {},
    clearForm() {
      this.editDialog = false;
      this.preceptStatusDialog = false;
    },
  },
  created() {},
  mounted() {
    this.getPageListInfo();
  }
};
</script>

<style lang="less">
.financeManage-precept-page {
  width: 100%;
  height: 500px;
  .hasBottomLine {
    width: 100%;
    padding-bottom: 18px;
    font-size: 18px;
    margin-bottom: 18px;
    font-weight: bold;
    border-bottom: 1px solid #cccccc;
  }

  .header-seach-box {
    width: 100%;
    margin-bottom: 30px;
    display: flex;
    .inputWithSelectBox {
      width: 500px;
      display: flex;
      .el-input-group__prepend {
        .el-select {
          width: 120px;
        }
      }
      .el-input-group__append {
        background: #409eff;
        color: #ffffff;
      }
    }
    .toTransLfet {
      margin-left: 30px;
    }

    .setSelect {
      margin-left: 30px;
      .el-select {
        margin-left: 12px;
      }
    }
  }

  .table-box {
    width: 100%;
    overflow: hidden;
    .el-table {
      .el-table__header-wrapper {
        .el-table__header {
          text-align: center;
          .cell {
            text-align: center;
          }
        }
      }
      .el-table__body-wrapper {
        .cell {
          text-align: center;
        }
      }
    }
  }

  .footer-box {
    padding: 20px 20px 50px 0px;
  }
  .configItem {
    margin-bottom: 50px;
    padding-bottom: 30px;
    border-bottom: 1px solid #cccccc;
    .item-title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 18px;
      display: flex;
      align-items: center;
      .el-button {
        margin-left: 50px;
      }
    }
    .item-action {
      display: flex;
      .desc-box {
        margin-right: 30px;
        .imitateInput {
          min-width: 60px;
          padding: 12px 20px;
          display: inline-block;
          text-align: center;
          border: 1px solid #cccccc;
          margin: 0 12px 0;
        }
      }

      .el-switch.is-disabled {
        opacity: 1;
      }
      .el-switch .is-disabled .el-switch__core,
      .el-switch.is-disabled .el-switch__label {
        cursor: pointer;
      }

      .el-switch.is-disabled .el-switch__core,
      .el-switch.is-disabled .el-switch__label {
        cursor: pointer;
      }
    }
    .item-remark {
      color: #ff8839;
      padding: 1px 0 22px 0;
    }
  }

}
</style>
